import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';
import { normalizeLocale } from './locales';

const initialLocale = normalizeLocale(
  typeof window !== 'undefined'
    ? window.localStorage.getItem('agentcad.locale') ?? navigator.language
    : 'en',
);

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale,
  fallbackLng: 'en',
  ns: ['common', 'prompt', 'intake', 'auth', 'landing', 'contact', 'privacy', 'terms', 'errorPage'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;

